import React from 'react';
import {LoadCardContainer, Banner, LoadImage} from '../styles/loadcard_styles';

const LoadCard = (props) => {
  const load_image = require("../images/loadimage.jpg")
  return(
    <LoadCardContainer>
      <Banner>
        <LoadImage src={load_image} alt="food image" />
        <p> Find your next experience. </p>
      </Banner>
    </LoadCardContainer>
  )
}

export default LoadCard;
